import React, { useRef } from "react";
import PageBanner from "../../containers/global/page-banner";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
import LawoData from "../../data/lawoc.json";
import LawoContainer from "../../containers/customer-service/lawo-collateral";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";

const LawocPage = () => {
    const contRef = useRef(null);
    const handleScrollToHeader = () => {
        console.log("scrllheader", contRef);
        if (contRef.current) {
            console.log("scrllheader2");
            // Adjust scrolling to account for the height of the small div
            const headerPosition = contRef.current.offsetTop;
            const divHeight = 0; // Adjust this if your div's height changes
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Loan Agreements (Without Collateral) | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header
                        onPressSkipButton={() => {
                            handleScrollToHeader();
                        }}
                    />
                    <PageBanner
                        title="Loan Agreements (Without Collateral)"
                        excerpt=""
                        image="/images/banner/page/company-policies.png"
                    />
                    <LawoContainer contRef={contRef} data={LawoData} />

                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default LawocPage;
